/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { redirect } from "../utils";

function Login({ location }) {
  useEffect(() => {
    if (location.pathname === '/beneficiario' || window.location.search.includes('type=beneficiario'))
      redirect(process.env.REACT_APP_API_SIGNIN_BENEFICIARIO);

    if (location.pathname === '/particular' || window.location.search.includes('type=particular'))
      redirect(process.env.REACT_APP_API_SIGNIN_PARTICULAR);

    if (location.pathname === '/suporte' || window.location.search.includes('type=suporte'))
      redirect(process.env.REACT_APP_API_SIGNIN_SUPORTE);

    if (location.pathname === '/medico' || window.location.search.includes('type=medico'))
      redirect(process.env.REACT_APP_API_SIGNIN_MEDICO);
  }, []);

  return <div className="App"></div>;
}

export default Login;
